import React from 'react';
import { TableRow, TableCell, Checkbox, Link } from '@mui/material';

const ContactRow = ({
  id,
  smsContact,
  onClick,
  selectRowsToBeDeleted,
  deleteContactList,
  accessLevel,
  accessType,
}) => (
  <TableRow>
    <TableCell title={smsContact.contact_name}>
      <Link onClick={onClick} tabIndex={0}>
        {smsContact.contact_name}
      </Link>
    </TableCell>
    <TableCell>
      <Link onClick={onClick} tabIndex={0}>
        {smsContact.contact_email}
      </Link>
    </TableCell>
    <TableCell>
      <Link onClick={onClick} tabIndex={0}>
        {smsContact.contact_tn}
      </Link>
    </TableCell>
    <TableCell>
      {smsContact.contact_type === 'global' ? 'Global' : 'Personal'}
    </TableCell>
    <TableCell title={smsContact.lists}>{smsContact.lists}</TableCell>
    <TableCell align="right">
      <Checkbox
        name="deleteCheckbox"
        disabled={
          (accessLevel > 0 && accessType > 0) ||
          smsContact.contact_type === 'personal'
            ? false
            : true
        }
        onChange={() => selectRowsToBeDeleted(id)}
        sx={{ padding: 0 }}
        checked={deleteContactList.includes(id)}
      />
    </TableCell>
  </TableRow>
);

export default ContactRow;
